import axios from "axios";

export default function (context, val) {
  let ag = context.state.list.filter(i => {
    return i.code === val.code;
  })[0];
  let request = val.requests[0];
  if (!request) return;
  if (val.currency === context.rootState.finances.pay.form.CurrencyId) {
    ag.course = 1;
    return;
  }
  axios({
    method: 'get',
    url: '/tourclient/currencyRates?currencyId=' + val.currency
      + '&secondCurrencyId=' + context.rootState.finances.pay.form.CurrencyId
      + '&date.Serialized=' + val.date
      + '&operatorId=' + request.operatorId
      + '&ignoreOperatorOrAgencySetting=true'
      + '&_=' + new Date().getTime()
  }).then(({ data }) => {
    if (data && data.ResultQueryInfo && data.ResultQueryInfo.HasError) {
      window.app.$notify.warning({
        message: data.ResultQueryInfo.UserMessages,
      });
      return;
    }
    ag.course = data.Value ? data.Value : 1;
  }).catch(e => {
    window.app.$notify.warning({
      message: 'Не удалось получить курс',
    });
  });
}
